export default __webpack_public_path__ + "static/media/gallery04.8c675efb.jpg";